"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApolloErrorHandlerResult = void 0;
const types_1 = require("./types");
class ApolloErrorHandlerResult {
    constructor(unhandledErrors, handledErrors) {
        this.unhandledErrors = unhandledErrors;
        this.handledErrors = handledErrors;
        this.allErrors = [...unhandledErrors, ...handledErrors];
    }
    get networkErrors() {
        return this.allErrors.filter((e) => e.type === types_1.ApolloErrorType.NETWORK_ERROR);
    }
    get serverErrors() {
        return this.allErrors.filter((e) => e.type === types_1.ApolloErrorType.SERVER_ERROR);
    }
    get unauthorizedErrors() {
        return this.allErrors.filter((e) => e.type === types_1.ApolloErrorType.UNAUTHORIZED_ERROR);
    }
    get userInputErrors() {
        return this.allErrors.filter((e) => e.type === types_1.ApolloErrorType.BAD_USER_INPUT);
    }
    get inputValidationErrors() {
        return this.allErrors.filter((e) => e.type === types_1.ApolloErrorType.INPUT_VALIDATION_ERROR);
    }
    get validationRuleViolations() {
        return this.inputValidationErrors.flatMap(e => e.violations);
    }
}
exports.ApolloErrorHandlerResult = ApolloErrorHandlerResult;
//# sourceMappingURL=ApolloErrorHandlerResult.js.map